import axios from "axios";
import {getToken} from "../utils/helper";


const access_token = getToken();
const API_URL = process.env.REACT_APP_GATEWAY_API;
axios.defaults.headers.common.Authorization = access_token
  ? `Bearer ${access_token}`
  : "";
axios.defaults.timeout = 60000;
axios.defaults.baseURL = API_URL;

axios.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response: any): any => {
    if (response.status >= 200) {
      return {
        status: response.status,
        success: true,
        ...response,
      };
    }
  },
  (error: any) => {
    if (error?.response && [502, 503].includes(error?.response?.status)) {
      window.location.replace("/internal-server-error");
    }

    if (error?.response && error?.response?.status === 404) {
      // window.location.replace("/404");
    }

    if (error?.response && [401, 403, 409, 400].includes(error?.response.status)) {
      if (window) {
        // window.location.replace("/session-expired");
      }
      return Promise.resolve(error);
    }

    // if (error?.response && [400].includes(error?.response.status)) {
    //   return Promise.reject(error);
    // }

    return Promise.reject(error);
  }
);
